import { IIntegrationApplication, IEnableField } from '@api/integration/types'

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email)

export const reduceAllFields = (applications: IIntegrationApplication[]) =>
  applications.reduce((all: IEnableField[], application) => {
    const reducedFiled = application.fields.reduce((a: IEnableField[], { name, value }) => {
      a.push({ name, value })
      return a
    }, [])
    return [...all, ...reducedFiled]
  }, [])

export const reduceAppFields = (applications: IIntegrationApplication[], selectedTabId: string) => {
  const app = applications.find(({ name }) => name === selectedTabId)

  if (!app) {
    return [] as IEnableField[]
  }

  return app.fields.reduce((a: IEnableField[], { name, value }) => {
    a.push({ name, value })
    return a
  }, [])
}

export const capitalize = (text: string): string =>
  text.length ? text[0].toUpperCase() + text.substring(1, text.length) : ''
